module.exports = __webpack_public_path__ + "src/assets/games/19/456.jpg";